export default __webpack_public_path__ + "static/media/icon-import.973aaa57.svg";